var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.76 10.5346L17.49 16.2647L16 17.7547L10.27 12.0246C9.2 12.7947 7.91 13.2647 6.5 13.2647C2.91 13.2647 0 10.3546 0 6.76465C0 3.17465 2.91 0.264648 6.5 0.264648C10.09 0.264648 13 3.17465 13 6.76465C13 8.17465 12.53 9.46465 11.76 10.5346ZM6.5 2.26465C4.01 2.26465 2 4.27465 2 6.76465C2 9.25465 4.01 11.2646 6.5 11.2646C8.99 11.2646 11 9.25465 11 6.76465C11 4.27465 8.99 2.26465 6.5 2.26465Z",
    fill: "#D5E4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.aa5dd7fb9b02ee9392b00a6b04f8d76a.svg";
export { ForwardRef as ReactComponent };